import NoSleep from "nosleep.js";

const initState = {
  authError: null,
  loading: false,
  resetError: null,
  status: null,
  vai: null,
  audio: new Audio(),
  nosleep: new NoSleep(),
  direct: true,
  geo: null,
};

const authReducer = (state = initState, action) => {
  console.log(action.type);

  switch (action.type) {
    case "RESET_EMAIL_SENT":
      console.log("reset email sent");
      return {
        ...state,
        resetError:
          "Un e-mail avec un lien de réinitialisation a été envoyé à votre adresse e-mail. Veuillez suivre les instructions de l'e-mail pour réinitialiser le mot de passe de votre compte.",
      };

    case "GEO_REC":
      console.log("GEO_REC", action.cc);
      return {
        ...state,
        geo: action.cc,
      };

    case "SET_DIRECT":
      console.log("SET_DIRECT");
      return {
        ...state,
        direct: false,
      };

    case "RESET_EMAIL_ERROR":
      console.log("reset email error");
      return {
        ...state,
        resetError: "L'e-mail fourni ne correspond à aucun compte.",
      };

    case "RESET_LOADING":
      console.log("reset loading");
      return {
        ...state,
        loading: true,
      };

    case "RESET_LOADING_STOP":
      console.log("reset loading stop");
      return {
        ...state,
        loading: false,
      };

    case "SIGNUP_LOADING":
      console.log("signup loading");
      return {
        ...state,
        loading: true,
        status: null,
        authError: null,
      };

    case "SIGNUP_LOADING_STOP":
      console.log("signup loading stop");
      return {
        ...state,
        loading: false,
      };

    case "LOGIN_LOADING":
      console.log("login loading");
      return {
        ...state,
        loading: true,
      };

    case "LOGIN_LOADING_STOP":
      console.log("login loading");
      return {
        ...state,
        loading: false,
      };

    case "LOGIN_ERROR":
      console.log("login error");
      return {
        ...state,
        authError: "La connexion a échoué, veuillez réessayer.",
      };

    case "LOGIN_DISABLED":
      console.log("login error");
      return {
        ...state,
        authError:
          "Votre compte est toujours en attente d'approbation. Veuillez contacter l'assistance.",
      };

    case "LOGIN_BANNED":
      console.log("login error");
      return {
        ...state,
        authError: "Votre compte a été banni. Veuillez contacter l'assistance.",
      };

    case "APP_SUMO_WRONG":
      console.log("login error");
      return {
        ...state,
        authError: "Le code AppSumo saisi n'est pas valide. Veuillez réessayer.",
      };

    case "LOGIN_SUCCESS":
      console.log("login success");
      return {
        ...state,
        authError: null,
        vai: true,
      };

    case "SIGNOUT_SUCCESS":
      console.log("signout success");
      return state;

    case "SIGNUP_SUCCESS":
      console.log("signup success");
      return {
        ...state,
        authError: null,
      };

    case "SIGNUP_SUCCESS_DISABLED":
      console.log("signup success");
      return {
        ...state,
        authError: null,
        status:
          "Votre compte a été créé avec succès. Un membre de notre équipe activera votre compte dans les plus brefs délais.",
      };

    case "SIGNUP_ERROR":
      console.log("signup error", action.err.message);
      return {
        ...state,
        authError: action.err.message,
      };

    default:
      return state;
  }
};

export default authReducer;
